import { createSlice , createAsyncThunk } from "@reduxjs/toolkit";
import { getAllSubtopicApi } from "../../apis/curriculumManagement";

export const getAllSubtopics= createAsyncThunk("subtopic/getAll", async () =>{
    const response = await getAllSubtopicApi();
    return response.data.data;

})

const subtopicSlice = createSlice({
  name: "subtopics",
  initialState: {
    subtopics: [],
    status: "idle",
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.subtopics = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSubtopics.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllSubtopics.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.subtopics = action.payload;
      })
      .addCase(getAllSubtopics.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default subtopicSlice.reducer